export default __webpack_public_path__ + "static/media/ugyLogo.484c0ee8.png";